import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  Environment,
  AssignFduToUserModel,
  FduRenderModel,
  FunzioniDivisioneUtente,
  IsError,
  DirittiFdu,
} from '../../models/-index';
import { Observable } from 'rxjs';

import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class FunzioniDivisioneUtenteService extends CrudGenericsService<FunzioniDivisioneUtente, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/FunzioniDivisioneUtente`);
    this.base = `${env.apiUrl}/api/FunzioniDivisioneUtente/`;
  }

  ClickAccessModifyFdu(id: number, campo: string): Observable<FunzioniDivisioneUtente> {
    const u = this.base + 'ClickAccessModifyFdu?id=' + id + '&campo=' + campo;
    return this.http.post<FunzioniDivisioneUtente>(`${u}`, null);
  }
  // sysa : auth component
  Get_byUtente(id: number) {
    const u = this.base + 'Get_byUtente/' + id;
    return this.http.get<FunzioniDivisioneUtente[]>(`${u}`);
  }
  // sys in funzioni modelli
  GetFDU_ByFunzioneByDivisioneRu(fun: string, div: number): Observable<FunzioniDivisioneUtente> {
    const u = this.base + 'GetFDU_ByFunzioneByDivisioneRu?fun=' + fun + '&div=' + div;
    return this.http.get<FunzioniDivisioneUtente>(`${u}`);
  }

  AssignFduToUser_ByModel(model: AssignFduToUserModel[]) {
    const u = this.base + 'AssignFduToUser_ByModel';
    return this.http.post(`${u}`, model);
  }
  AssignFduToUser_ByModelloByUtente_AllDivs(model: number, uid: string) {
    const u = this.base + 'AssignFduToUser_ByModelloByUtente_AllDivs?model=' + model + '&uid=' + uid;
    return this.http.post(`${u}`, null);
  }
  AssignFduToUser_ByModelloByUtenteByDiv(model: number, uid: string, div: string) {
    const u = this.base + 'AssignFduToUser_ByModelloByUtenteByDiv?model=' + model + '&uid=' + uid + '&div=' + div;
    return this.http.post(`${u}`, null);
  }
  /*  non usata
  AssignFduToUser_SimulateLogin(model: number, uid: string, div: string) {
    const u = this.base + 'AssignFduToUser_SimulateLogin?model=' + model + '&uid=' + uid + '&div=' + div;
    return this.http.post(`${u}`, null);
  }*/
  // sys : utente  > notification sub  component
  /*GetFDU_ByUtenteByDivisione(ute: string, div: number): Observable<FunzioniDivisioneUtente[]> {
    const u = this.base + 'GetFDU_ByUtenteByDivisione?ute=' + ute + '&div=' + div;
    return this.http.get<FunzioniDivisioneUtente[]>(`${u}`);
  }*/
  GetFduRenderModel_ByUtenteByDivisione(ute: string, div: number): Observable<FduRenderModel[]> {
    const u = this.base + 'GetFduRenderModel_ByUtenteByDivisione?ute=' + ute + '&div=' + div;
    return this.http.get<FduRenderModel[]>(`${u}`);
  }
  // sysa : utente  > notification sub  component
  Get_ByFunzioneByDivisioneByCampo(fdu: string, div: number, campo: string): Observable<FunzioniDivisioneUtente[]> {
    const u = this.base + 'Get_ByFunzioneByDivisioneByCampo?fdu=' + fdu + '&div=' + div + '&campo=' + campo;
    return this.http.get<FunzioniDivisioneUtente[]>(`${u}`);
  }
  // sysa : utente  > notification sub  component
  Set_ByFunzioneByDivisioneByUtenteByCampo(fdu: string, div: number, ute: string, campo: string): Observable<IsError> {
    const u =
      this.base + 'Set_ByFunzioneByDivisioneByUtenteByCampo?fdu=' + fdu + '&div=' + div + '&ute=' + ute + '&campo=' + campo;
    return this.http.post<IsError>(`${u}`, null);
  }
  // -----------diritti in sys versione 2023 ----------- //
  // una copuia è in securityservice chiamate direttamente

  GetAllDirittiFDU(): Observable<DirittiFdu[]> {
    const u = `${this.base}GetAllDirittiFDU`;
    return this.http.get<DirittiFdu[]>(u);
  }
  GetDirittiFDU_byFunzione(id: string): Observable<DirittiFdu> {
    const u = `${this.base}GetDirittiFDU_byFunzione?id=${id}`;
    return this.http.get<DirittiFdu>(u);
  }
}
